/**
 * @file Purchase Album header.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Header from '../global/Header';
import Logo from '../global/Logo';
import MobileHeaderSupportButton from '../product/MobileHeaderSupportButton';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    display_name: PropTypes.string,
  }),
  openModal: PropTypes.func.isRequired,
};

const defaultProps = {
  album: {
    id: '',
    display_name: '',
  },
};

const PurchaseAlbumHeader = ({ album, openModal }) => (
  <Fragment>
    <Header>
      <div className="site-brand">
        <Logo linksTo={`/purchase/album/${album.id}`} iconOnly />
      </div>

      <h3 className="site-title-center">
        {album.display_name}
        {album.display_name !== album.name && (
          <span className="site-title-center-subtitle">{album.name}</span>
        )}
      </h3>

      <MobileHeaderSupportButton className="ml-auto" openModal={openModal} />
    </Header>
  </Fragment>
);

PurchaseAlbumHeader.propTypes = propTypes;
PurchaseAlbumHeader.defaultProps = defaultProps;

export default PurchaseAlbumHeader;
